import { useEffect,useRef,type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export default function PanelDialog({ title,onClose,children }: { title:string;onClose:()=>void;children:ReactNode }) {
  const dialog=useRef<HTMLDialogElement>(null);
  useEffect(()=>{ const element=dialog.current;const previous=document.activeElement as HTMLElement | null;element?.showModal();
    return ()=>{ element?.close();previous?.focus(); };
  },[]);
  return createPortal(<dialog ref={dialog} aria-label={title} onCancel={event=>{ event.preventDefault();onClose(); }}
    className="m-auto max-h-[90dvh] w-[min(1100px,95vw)] rounded-2xl bg-white p-0 shadow-2xl backdrop:bg-slate-900/40">
    <header className="sticky top-0 z-10 flex items-center justify-between border-b bg-white p-4"><h2 className="font-semibold">{title}</h2><button aria-label="Kapat" onClick={onClose} className="rounded-lg p-2 hover:bg-slate-100"><X size={18}/></button></header>
    <div className="space-y-4 p-4">{children}</div>
  </dialog>,document.body);
}
